import baseAxios, { AxiosInstance } from "axios";
import qs from "querystring";

interface AccountAxios extends AxiosInstance {
  setToken?: (token: string) => void;
}

declare global {
  interface Window {
    REACT_APP_ACCOUNT_API_HOST: string;
  }
}

export const accountURL = `${
  window.REACT_APP_ACCOUNT_API_HOST || process.env.REACT_APP_ACCOUNT_API_HOST
}`;

const axios: AccountAxios = baseAxios.create({
  baseURL: accountURL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => qs.stringify(params),
});

axios.setToken = (token: string) => {
  if (token) {
    axios.defaults.headers["Authorization"] = `Bearer ${token}`;
  }
};

const { get, post, put } = axios;
export { get, post, put, axios };
